var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"100vh"}},[_c('iframe',{staticStyle:{"position":"relative","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"src":_vm.url_data,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }